import React from 'react';
import classNames from 'classnames';
import PreloadImages from 'Components/PreloadImages';
import useStartPage from 'Hooks/useStartPage';
import ConbiniColor from 'Img/conbini-color.svg';
import FulltimeIcon from 'Img/fulltime-icon.svg';
import HomeIcon from 'Img/home-icon.svg';
import ParttimeIcon from 'Img/parttime-icon.svg';
import ResumeIcon from 'Img/resume-icon.svg';
import JsvMetricsLogger from 'Utils/JsvMetricsLogger';
import PlatformUtil from 'Utils/PlatformUtil';
import DesktopStartPage from './_DesktopStartPage';
import StartPageLinks from './StartPageLinks';
import './StartPage.scss';
const StartPage = () => {
    const { handleClickStart } = useStartPage();
    if (PlatformUtil.isDesktop()) {
        return React.createElement(DesktopStartPage, null);
    }
    JsvMetricsLogger.log('page_view', 'show_tos_screen', 'tos_screen');
    return (React.createElement("div", { className: classNames('StartPage', 'CelebrityStartPage') },
        React.createElement(PreloadImages, { images: [FulltimeIcon, ParttimeIcon, HomeIcon, ResumeIcon, ConbiniColor] }),
        React.createElement("div", { className: "content" },
            React.createElement("div", { className: "bubble", "aria-label": "hidden" },
                React.createElement("h1", null, "\u5C65\u6B74\u66F8\u4F5C\u6210\u3078\u3088\u3046\u3053\u305D!"),
                React.createElement("p", null, "\u4ECA\u307E\u3067\u624B\u66F8\u304D\u3067\u4F5C\u6210\u3057\u3066\u3044\u305F\u5C65\u6B74\u66F8\u3092\u3001\u30B9\u30DE\u30DB\u3067\u30AB\u30F3\u30BF\u30F3\u4F5C\u6210\uFF01")),
            React.createElement("div", { className: "jobbi", "aria-label": "hidden" })),
        React.createElement(StartPageLinks, { onClickStart: handleClickStart })));
};
export default StartPage;
